import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export interface SaleSaveCollectiveIdentifierCommandParams {
    ksefNumbers: string[];
    collectiveIdentifier: string;
}

export type SaleSaveCollectiveIdentifierResponse = void;

export class SaleSaveCollectiveIdentifierCommand extends Command<SaleSaveCollectiveIdentifierCommandParams, SaleSaveCollectiveIdentifierResponse> { }

@CommandHandlerFor(SaleSaveCollectiveIdentifierCommand)
@Injectable({ providedIn: 'root' })
export class SaleSaveCollectiveIdentifierCommandHandler {
    #url = TaggedUrl.join('eInvoices/collective-identifier/link', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync({ params }: SaleSaveCollectiveIdentifierCommand): Promise<SaleSaveCollectiveIdentifierResponse> {
        await this.#http.post(this.#url, { collectiveIdentifier: params?.collectiveIdentifier, ksefNumbers: params?.ksefNumbers });
    }
}
